import { render } from "./DemoBanner.vue?vue&type=template&id=5cc9963a&scoped=true&ts=true"
import script from "./DemoBanner.vue?vue&type=script&lang=ts"
export * from "./DemoBanner.vue?vue&type=script&lang=ts"

import "./DemoBanner.vue?vue&type=style&index=0&id=5cc9963a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc9963a"]])

export default __exports__